export default "__VITE_ASSET__64083477__"